import { Component } from "react";
import "./InformationStyle.css";

class InformationData extends Component {
  render() {
    return (
      <div className="tReview">
        <div className="description-text">
          <h2>{this.props.heading}</h2>
          <p className="quote">
            "{this.props.text}" <br /> <br />"{this.props.text2}"
            <br /> <br />
          </p>
          <span>Check out more here:</span>
          <br />
          <a
            className="linkrev"
            href={this.props.url}
            target="_blank"
            rel="noreferrer"
          >
            {this.props.reviewLink}
          </a>
        </div>
        <div className="image">
          <img alt="img" src={this.props.img1} />
          <img alt="img2" src={this.props.img2} />
        </div>
      </div>
    );
  }
}

export default InformationData;
